export const SalesforceCompanyTypes: { id: number, name: string }[] = [
    {
        id: 1,
        name: "Charterer - Bulk"
    }, {
        id: 2,
        name: "Charterer - Tanker"
    }, {
        id: 3,
        name: "Class"
    }, {
        id: 4,
        name: "Financial"
    }, {
        id: 5,
        name: "Flag"
    }, {
        id: 6,
        name: "Insurance"
    }, {
        id: 7,
        name: "P&I Club"
    }, {
        id: 8,
        name: "Port"
    }, {
        id: 9,
        name: "Ship Manager"
    }, {
        id: 10,
        name: "Ship Owner"
    }, {
        id: 11,
        name: "Terminal"
    }, {
        id: 12,
        name: "Other"
    }];